@if (isLoading | async) {
  <div class="spinner-overlay d-flex justify-content-center align-items-center">
    <div class="spinner-wrapper d-flex flex-column justify-content-center align-items-center">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}